import React, { Component } from 'react';
import style from '../share/pageList.module.css';

import TextBoxWithLabel from '../../components/TextBoxWithLabel.js';
import DropDownWithLabel from '../../components/DropDownWithLabel.js';
import DatePickerWithLabel from '../../components/DatePickerWithLabel.js';
import DefaultBtn from '../../components/DefaultBtn.js';
import Paging from '../../components/Paging.js';
//import * as utils from '../../components/Utils.js';
import BackDropLoading from '../../components/BackDropLoading.js';
//import axios from 'axios';
import TemplateV2 from '../../components/TemplateV2';
import * as utils from '../../Utils.js';



class ReservationList extends Component {

    constructor(props) {
        //alert("Hotel");


        //console.log(this.props.appState.userObject);

        super(props);
        this.state = {
            //showCreate: false,
            //showDelete: false,
            //showDetail:false,
            //selectId: null,
            //selectMethod: "",
            loading: false,
            dataObject: null,
            searchObject: {
                searchWord: "",
                searchType: "bookingref",
                searchTypeList: [
                    { value: "bookingref", label: "Booking Ref" },
                    { value: "roomref", label: "Room Ref" },
                    { value: "company", label: "Company" },
                    { value: "hotel", label: "Hotel" },
                    { value: "costcenter", label: "Cost center" },
                    { value: "guest", label: "Guest Name" },
                    { value: "booker", label: "Booker Name" },
                    
                ],
                paymentTypeList: [
                    { value: "", label: "All" },
                    { value: "payUponArrival", label: "pay upon arrival" },
                    { value: "creditCard", label: "credit card" },
                    { value: "billing", label: "billing" },
                ],
                statusTypeList: [
                    { value: "", label: "All" },
                    { value: "1", label: "Waiting for payment" },
                    { value: "2", label: "Waiting for approve" },
                    { value: "4", label: "Confirm" },
                    { value: "8", label: "Deny" },
                    { value: "9", label: "Cancel" },
                    { value: "10", label: "Cancel by system" }
                ],
                statusType: "",
                paymentType: "",

                companyId: null,
                dateFrom: null,
                dateTo: null,
                dateType: "bookingdate",
                dateTypeList: [
                    { value: "bookingdate", label: "Booking Date" },
                    { value: "datein", label: "Date In" },
                    { value: "dateout", label: "Date Out" },
                ]
            },
            //Page: 1
        };
        this.Page = 1;
    }
    componentDidMount() {
        this.props.appState.checkUser(this.props.appState);
        if (this.props.site === "hopinn") {
            this.props.appState.checkRoles(this.props.appState, ["HopinnAdmin", "SystemAdmin"]);
        }
        this.callGetData();
    }
    handleChange = (e) => {
        let searchObject = { ...this.state.searchObject };
        if (e.target.name === "dateType") {
            searchObject.dateType = e.target.value;
        }
        if (e.target.name === "dateFrom") {
            searchObject.dateFrom = e.target.value;
        }
        if (e.target.name === "dateTo") {
            searchObject.dateTo = e.target.value;
        }
        if (e.target.name === "searchType") {
            searchObject.searchType = e.target.value;
        }
        if (e.target.name === "searchWord") {
            searchObject.searchWord = e.target.value;
        }

        if (e.target.name === "statusType") {
            searchObject.statusType = e.target.value;
        }
        if (e.target.name === "paymentType") {
            searchObject.paymentType = e.target.value;
        }
        this.setState({
            searchObject: searchObject
        })
    }
    pagingClick = (page) => {
        this.Page = page;
        this.callGetData();
    }
    searchClick = () => {
        this.callGetData();
    }
    exportClick = () => {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/WorkflowReportRequest";
        let data = {};

        data.searchObject = { ...this.state.searchObject };
        data.Page = this.Page;
        let appState =   this.props.appState;
        let token = appState.userObject.Token;
        utils.callPost(url,token,data,this.exportCallBack);

        this.setState({
            loading: true
        })
    }
    exportCallBack=(data)=> {
        let url = process.env.REACT_APP_API_END_POINT + "/WorkflowReport/bookingreport/" + data;
        let windowName = "";
        window.open(url, windowName, "height=500,width=500", "_blank");
        this.setState({
            loading: false
        })

    }
    callGetData() {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/reservationbybillinglist";
        let data = {};

        data.searchObject = { ...this.state.searchObject };
        data.searchObject.companyId = this.props.appState.userObject.companyId;
        data.Page = this.Page;
        let appState= this.props.appState;
        let token = appState.userObject.Token;
        utils.callPost(url,token,data,this.callGetDataCallBack);

        this.setState({
            loading: true
        })
    }
    callGetDataCallBack=(res)=> {
        let data = res.Data;
        this.setState({
            dataObject: { ...data },
            loading: false
        })
    }


    handleClick = (method, index, e) => {
        if (method === "details") {

            //window.location.replace("http://sidanmor.com");
            //window.location.href = "http://sidanmor.com";

            let url = "";
            if (this.props.site === "company") {
                url = "/management/company/workflow/details/" + e;
            }
            else {
                url = "/management/workflow/details/" + e;
            }
            window.location.href = url;
            //alert(e);
        }
    }
    renderTable() {
        let tableRow = [];
        let dataObject = this.state.dataObject;

        if (dataObject !== null) {
            let dataList = dataObject.dataList;

            for (let i = 0; i < dataList.length; i++) {
                let node = dataList[i];
                //let active = node.IsEnable === true ? "Enable" : "Disable";
                //let guest = node.givenName + " " + node.surName;
                //let balance = utils.numberWithCommas(node.balance, 2);
                //let status = "booked";
                // if(node.status === 9){
                //     status = "cancel";
                // }

                let bookingDate = utils.stringToDateWithTime(node.bookingDate);
                let dateIn  = utils.stringToDateWithTime(node.dateInDateTime);
                let dateOut = utils.stringToDateWithTime(node.dateOutDateTime);

                let statusText = "";
                if(node.status ===1){
                    statusText = "Reservation";
                }
                if(node.status ===5){
                    statusText = "CheckOut";
                }
                if(node.status ===6){
                    statusText = "Invoiced";
                }
                else if(node.status ===9){
                    statusText = "CancelByUser";
                }
                else if(node.status ===10){
                    statusText = "CancelBySystem";
                }

                let isCheckOut = node.isCheckOut === true? "true" : "false";
                let isInvoice = node.isInvoice === true? "true" : "false";
                let isWarning = node.isWarning === true? "true" : "false";


                tableRow.push(
                    <tr key={node.Id}>
                        <td className={style.td}><div className={style.booking_ref} onClick={(e) => this.handleClick("details", null, node.bookingTransactionId)}>{node.bookingRef}</div></td>
                        <td className={style.td}>{statusText}</td>
                        <td className={style.td}>{node.paymentMethod}</td>
                        <td className={style.td}>{bookingDate}</td>
                        <td className={style.td}>{dateIn}</td>
                        <td className={style.td}>{dateOut}</td>
                        <td className={style.td}>{node.tripNo}</td>
                        <td className={style.td}>{node.hotelCode}</td>
                        <td className={style.td}>{node.hotelName}</td>
                        <td className={style.td}>{node.roomNo}</td>
                        <td className={style.td}>{node.reservationCode}</td>
                        <td className={style.td}>{node.roomTypeName}</td>
                        <td className={style.td}>{node.ratePlanName}</td>
                        <td className={style.td}>{node.guests}</td>
                        <td className={style.td}>{node.booker}</td>
                        <td className={style.td}>{node.companyName}</td>
                        <td className={style.td}>{node.costCenter}</td>
                        <td className={style.td}>{utils.numberWithCommas(node.averageRate)}</td>
                        <td className={style.td}>{node.duration}</td>
                        <td className={style.td}>{node.amountAfterTaxRoom}</td>
                        <td className={style.td}>{isCheckOut}</td>
                        <td className={style.td}>{isInvoice}</td>
                        <td className={style.td}>{isWarning}</td>


                        {/* <td className={style.td}>{utils.numberWithCommas(node.total)}</td> */}
                        {/* <td onClick={(e) => this.showEdit(node.Id)} className={style.columnPointer}>{node.reservationCode}</td>
                        <td>{status}</td>
                        <td>{node.bookingDate}</td>
                        <td>{node.dateIn}</td>
                        <td>{node.dateOut}</td>
                        <td>{node.duration}</td>
                        <td>{guest}</td>
                        <td>{node.companyName}</td>
                        <td>{node.hotelName}</td>
                        <td>{balance}</td> */}
                    </tr>
                );
            }

        }
        return (
            <div className={style.tableArea}>
                <table>
                    <thead>
                        <tr>




                            <th className={style.th}>Booking Ref</th>
                            <th className={style.th}>status</th>
                            <th className={style.th}>payment method</th>
                            <th className={style.th}>Booking Date</th>
                            <th className={style.th}>Check In</th>
                            <th className={style.th}>Check Out</th>
                            <th className={style.th}>Trip No</th>
                            <th className={style.th}>Hotel Code</th>
                            <th className={style.th}>Hotel Name</th>
                            <th className={style.th}>Room No</th>
                            <th className={style.th}>Room Ref</th>
                            <th className={style.th}>Room Type Name</th>
                            <th className={style.th}>Rate Plan Name</th>
                            <th className={style.th}>Guests</th>
                            <th className={style.th}>Booker</th>
                            <th className={style.th}>Company</th>
                            <th className={style.th}>Cost Center</th>
                            <th className={style.th}>AverageRate</th>
                            <th className={style.th}>Night</th>
                            <th className={style.th}>Total</th>
                            <th className={style.th}>IsCheckOut</th>
                            <th className={style.th}>IsInvoice</th>
                            {/* <th className={style.th}>IsOutDate</th> */}
                            <th className={style.th}>IsWarning</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </table>
                {dataObject !== null &&
                    <Paging dataObject={dataObject} onClick={this.pagingClick} />
                }
            </div>
        );



    }




    render() {
        let table = this.renderTable();
        //alert(this.props.site);
        return (


            <TemplateV2 appState={this.props.appState} site={this.props.site} page={"reservationbybilling"}>
                <div className={style.page}>
                    <BackDropLoading show={this.state.loading} key="hotel" />

                    <div className={style.navBar}>
                        <div className={style.nav}>Home</div>
                        <i className="fas fa-chevron-right"></i>
                        <div className={style.navSelect}>Reservation by billing</div>
                        {/* <i className="fas fa-chevron-right"></i>
                    <div className={style.navSelect}>Create</div> */}
                    </div>

                    {this.state.showCreate !== true && this.state.loading !== true && this.state.showDelete !== true && this.state.showDetail !== true &&

                        <>
                            <div className={style.searchArea}>
                                <div className={style.searchBox}>



                                <div className={style.row}>
                                        <div className={style.searchBoxInput}>
                                            <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.statusTypeList} value={this.state.searchObject.statusType} name="statusType" label="Status" />
                                        </div>
                                        <div className={style.searchBoxInput}>
                                            <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.paymentTypeList} value={this.state.searchObject.paymentType} name="paymentType" label="Payment Type" />
                                        </div>
                                        
                                    </div>


                                    <div className={style.row}>
                                        <div className={style.searchBoxInput}>
                                            <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.dateTypeList} value={this.state.searchObject.dateType} name="dateType" label="Date Type" />
                                        </div>
                                        <div className={style.searchBoxInput}>
                                            <DatePickerWithLabel onChange={this.handleChange} value={this.state.searchObject.dateFrom} name="dateFrom" label="Date From" />
                                        </div>


                                        <div className={style.searchBoxInput}>
                                            <DatePickerWithLabel onChange={this.handleChange} value={this.state.searchObject.dateTo} name="dateTo" label="Date To" />
                                        </div>
                                    </div>

                                    




                                    <div className={style.row}>
                                        <div className={style.searchBoxInput}>
                                            <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.searchTypeList} value={this.state.searchObject.searchType} name="searchType" label="Search Type" />
                                        </div>

                                        <div className={style.searchBoxInput}>
                                            <TextBoxWithLabel onChange={this.handleChange} value={this.state.searchObject.searchWord} name="searchWord" label="Search Word" />
                                        </div>

                                        <div className={style.searchBoxBtn}>
                                            <DefaultBtn label="Search" type="primary" onClick={this.searchClick} />
                                        </div>
                                        {/* <div className={style.searchBoxBtn}>
                                            <DefaultBtn label="Export to excel" type="primary" onClick={this.exportClick} />
                                        </div> */}
                                    </div>










                                    {/* <div className={style.searchBoxInput}>
                                    <TextBoxWithLabel onChange={this.handleChange} value={this.state.searchObject.Name} name="reservationCode" label="Reservation Code" />
                                </div>

                                <div className={style.searchBoxInput}>
                                    <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.dateTypeList} value={this.state.searchObject.dateType} name="dateType" label="Date Type" />
                                </div>


                                <div className={style.searchBoxInput}>
                                    <DatePickerWithLabel onChange={this.handleChange} value={this.state.searchObject.dateFrom} name="dateFrom" label="Date From" />
                                </div>


                                <div className={style.searchBoxInput}>
                                    <DatePickerWithLabel onChange={this.handleChange} value={this.state.searchObject.dateFrom} name="dateTo" label="Date To" />
                                </div>








                                // <div className={style.searchBoxBtn}>
                                //     <DefaultBtn label="Search" type="primary" onClick={this.searchClick} />
                                // </div>
                                <div className={style.searchBoxBtn}>
                                    <DefaultBtn label="Export to excel" type="primary" onClick={this.exportClick} />
                                </div> */}
                                </div>
                            </div>

                            <div className={style.contentArea}>
                                <div className={style.contentBox}>
                                    <div className={style.contentTitle}>Reservation by billing</div>

                                    <div className={style.line}></div>

                                    {/* <div className={style.toolArea}>
                                            <div className={style.toolBtn} onClick={this.showCreate}>
                                                <i className="fas fa-plus"></i>
                                        Create
                                </div>
                                        </div> */}
                                    <div className={style.line}></div>
                                    {table}
                                </div>
                            </div>
                        </>
                    }
                </div>
            </TemplateV2>


        );
    }
}
export default ReservationList;